import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class TdspMediaPlanService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_TDSP_URL}/forecasting/`;

  generateMediaPlan(id, params) {
    let url = this.buildUrl(`${this.resource_url}${id}/run_forecast/`, "", params);
    return this.post(url, {});
  }

  getForecastingResults(id, params) {
    let url = this.buildUrl(`${this.resource_url}${id}/forecast_results/`, "", params);
    return this.get(url);
  }

}
